import moment from 'moment-with-locales-es6';
// JavaScript Document
import $ from "../lib/load_jquery";

$(function() {
	$('.filterAZ a').on('click', function(event) {
		var target = $($(this).attr('href'));
		event.preventDefault();
		if (target.length!=0) {
			var top = target.offset().top - $('.filterAZ').outerHeight();
			$.scrollTo(top + 'px', 800);
		}
	});


	/**
	 * Name           : Swipebox
	 * Beschreibung   : A touchable jQuery lightbox
	 * Parameter      : -
	 * Rückgabe       : -
	 * Bibliothek     : jQuery, https://brutaldesign.github.io/swipebox/
	 */
	$('.filterAZ').on('click','li a',function(){
		$(this).parent().parent().find('li a').removeClass('active');
		$(this).addClass('active');
	});

	/**
	 * Name           : Opening-Times
	 * Beschreibung   : -
	 * Parameter      : -
	 * Rückgabe       : -
	 * Bibliothek     : jQuery
	 */

	function checkOpeningTimes (){
		moment.locale('de');
		let now = moment().format('LT');
		let weekday = moment().day();
		let today = $('.key[data-weekday=' + weekday + ']');
		let successMessage = $('.placeOpen').data('msg-open');
		let message = $('.placeOpen').data('msg-closed');

		$('.placeOpen span').removeClass().addClass('error');

		let openingTimes = today.siblings('ul').find('li[data-type="open"]').each( function (index, item){
			let openingItem = {
				start: $(this).data('start'),
				end  : $(this).data('end'),
				status : 'closed'
			}

			if ( (now >= openingItem.start) && (now < openingItem.end) ){
				openingItem.status = 'open';
			}

			if (openingItem.status == 'open') {
				message = successMessage;
				$('.placeOpen span').removeClass().addClass('success');
				return message;
			}
		});
		$('.placeOpen span').text(message);
	}

	if ( $( ".placeOpenings" ).length ) {
		checkOpeningTimes();
		setInterval(function () {
			checkOpeningTimes();
		}, 10000);
	}

});